export const CONTENT_TYPES = {
  features: "features",
  faqs: "faqs"
}